"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortationUserJobLogError = exports.SortationUserJobType = void 0;
var SortationUserJobType;
(function (SortationUserJobType) {
    SortationUserJobType["SCANNER"] = "SCANNER";
    SortationUserJobType["NONSCANNER"] = "NONSCANNER";
})(SortationUserJobType = exports.SortationUserJobType || (exports.SortationUserJobType = {}));
var SortationUserJobLogError;
(function (SortationUserJobLogError) {
    SortationUserJobLogError["FAILED_TO_START_JOB"] = "FAILED_TO_START_JOB";
    SortationUserJobLogError["FAILED_TO_STOP_JOB"] = "FAILED_TO_STOP_JOB";
    SortationUserJobLogError["FAILED_TO_SAVE_MANUAL_JOBS"] = "FAILED_TO_SAVE_MANUAL_JOBS";
    SortationUserJobLogError["NO_ACTIVE_JOB_FOUND_FOR_USER"] = "NO_ACTIVE_JOB_FOUND_FOR_USER";
    SortationUserJobLogError["USER_ALREADY_HAS_ACTIVE_JOB"] = "USER_ALREADY_HAS_ACTIVE_JOB";
    SortationUserJobLogError["USER_HAS_MULTIPLE_ACTIVE_JOBS"] = "USER_HAS_MULTIPLE_ACTIVE_JOBS";
})(SortationUserJobLogError = exports.SortationUserJobLogError || (exports.SortationUserJobLogError = {}));
//# sourceMappingURL=SortationUserJob.js.map